<!--个人中心版本3-->
<template>
  <div class="mine-contain">
    <div>
      <div class="three-user-header">
        <div class="user-message user-message-three">
          <div class="user-detail">
            <div style="display: flex">
              <img class="user-img" :src="row.face" alt="" />
              <div class="add-user-head flex-between">
                <div class="user-detail-right">
                  <div class="user-name">{{ row.name }}</div>
                  <div class="user-invite" v-if="false">
                    <img
                      src="../../../assets/images/icon-top-authentication.png"
                      alt=""
                      srcset=""
                    />
                    <span class="userA-auth-title">实名认证</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="user-sing-in" v-if="false">
              <div class="user-sing-box">
                <img
                  @click="goSetting"
                  src="../../../assets/images/icon-top-Sign-in.png"
                />
              </div>
              <div>签到</div>
            </div>
          </div>
        </div>
        <div class="user-info-items">
          <div class="user-info-item1" v-rblink="{ name: 'Experience' }">
            <!--                        <div style="position: absolute;top:85px;left:5px"  @click="$toast('暂无记录')">-->
            <div style="position: absolute; top: 85px; left: 5px">
              <div class="infoItemsTitle">我的经历</div>
              <div class="infoItemsTitle2">运动员</div>
              <!--<div class="infoItemsTitle2">紫星级☆运动员</div>-->
              <!--<div class="infoItemsTitle2">3金2银1铜</div>-->
            </div>
          </div>
          <div class="user-info-item2" v-rblink="{ name: 'MineActivity' }">
            <div
              class="badge"
              v-if="row.activity_count > 0"
              style="position: absolute; top: 14px; left: 61px"
            >
              {{ row.activity_count }}
            </div>
            <div style="position: absolute; top: 85px; left: 5px">
              <div class="infoItemsTitle">我的活动</div>
              <div class="infoItemsTitle2">我报名的比赛</div>
              <div class="infoItemsTitle2">近期培训{{ row.huiyi_count }}场</div>
              <!--<div class="infoItemsTitle2">近期培训</div>-->
              <!--<div class="infoItemsTitle2">近期考级</div>-->
            </div>
          </div>
          <div class="user-info-item3" v-rblink="{ name: 'MyClub' }">
            <div style="position: absolute; top: 85px; left: 5px">
              <div class="infoItemsTitle">我的俱乐部</div>
              <div class="infoItemsTitle2">考级中心（点）</div>
              <!--<div class="infoItemsTitle2">运动员</div>-->
              <!--<div class="infoItemsTitle2">紫星级☆运动员</div>-->
              <!--<div class="infoItemsTitle2">3金2银1铜</div>-->
            </div>
          </div>
        </div>
        <div class="user-info-items2">
          <div class="info-itmes2-box" @click="$toast('正在完善中')">
            <img
              style="width: 27.5px; height: 35.5px"
              src="../../../assets/images/icon-Personal-Center-curriculum.png"
              alt=""
            />
            <div class="info-item-title">课程</div>
          </div>
          <div class="info-itmes2-box" @click="$toast('正在完善中')">
            <img
              style="width: 34.5px; height: 35.5px"
              src="../../../assets/images/icon-Personal-Center-dynamic.png"
              alt=""
            />
            <div class="info-item-title">动态</div>
          </div>
          <div class="info-itmes2-box" v-rblink="{ name: 'Vip' }">
            <img
              style="width: 34.5px; height: 35.5px"
              src="../../../assets/images/picon-Personal-Center-integral.png"
              alt=""
            />
            <div class="info-item-title">积分</div>
          </div>
          <div class="info-itmes2-box" @click="$toast('正在完善中')">
            <img
              style="width: 32.5px; height: 30.5px"
              src="../../../assets/images/icon-Personal-Center-order.png"
              alt=""
            />
            <div class="info-item-title">订单</div>
          </div>
        </div>
        <!--<div class="banner-img-box"> -->
        <!--<img  src='../../../assets/images/pic-Activity-Poster.png'/>-->
        <!--</div> -->
        <div class="user-setting-box">
          <div
            class="setting-items bottom-solid"
            v-rblink="{ name: 'MyInfo' }"
          >
            <div class="setting-items-left">
              <img
                class=""
                src="../../../assets/images/icon-Personal-Center-news.png"
                alt=""
                srcset=""
              />
              <span>认证信息</span>
            </div>
            <img
              class="setting-arrow"
              src="../../../assets/images/arrow.png"
              alt=""
            />
          </div>
          <div class="setting-items bottom-solid" v-rblink="{ name: 'Gbook' }">
            <div class="setting-items-left">
              <img
                class=""
                src="../../../assets/images/icon-Personal-Center-service.png"
                alt=""
                srcset=""
              />
              <span>客服</span>
            </div>
            <img
              class="setting-arrow"
              src="../../../assets/images/arrow.png"
              alt=""
            />
          </div>
          <div class="setting-items" v-rblink="{ name: 'UserSetting' }">
            <div class="setting-items-left">
              <img
                class=""
                src="../../../assets/images/icon-Personal-Center-set.png"
                alt=""
                srcset=""
              />
              <span>设置</span>
            </div>
            <img
              class="setting-arrow"
              src="../../../assets/images/arrow.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <TabBar :show-tab-bar="true"></TabBar>
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
  </div>
</template>
<style src="../../../assets/style/mine.css" scoped></style>
<style scoped>
/*@import '../../../assets/style/mine.css';*/
.setting-arrow {
  width: 5.5px;
  height: 10px;
}
.bottom-solid {
  border-bottom: 1px solid #f5f5f5;
}
.setting-items-left img {
  width: 22px;
  height: 22px;
}
.setting-items-left span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-left: 13px;
}
.setting-items-left {
  display: flex;
}
.setting-items {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 43px;
}
.user-setting-box {
  width: 6.6rem;
  background: #fff;
  border-radius: 10px;
  margin: 10px auto;
  padding: 0 10px;
}
.banner-img-box {
  margin-top: 10px;
  width: 7rem;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.banner-img-box img {
  width: 100%;
}
.info-item-title {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 10px;
}
.info-itmes2-box {
  width: 25%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.user-info-items2 img {
  width: 100%;
}
.user-info-items2 {
  width: 6.6rem;
  height: 1.34rem;
  background: #fff;
  border-radius: 10px;
  margin: 10px auto;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

.three-user-header {
  background: url("../../../assets/images/bg-mein-background1.png") no-repeat;
  background-size: 100%;
}
.user-info-item3 {
  width: 33%;
  height: 98%;
  background: url("../../../assets/images/pic-Personal-Center-club.png")
    no-repeat bottom;
  background-size: 100%;
  position: relative;
}
.user-info-item2 {
  width: 33%;
  height: 98%;
  background: url("../../../assets/images/pic-Personal-Center-activity.png")
    no-repeat bottom;
  background-size: 100%;
  position: relative;
}
.user-info-item1 {
  width: 33%;
  height: 98%;
  background: url("../../../assets/images/pic-Personal-Center-experience.png")
    no-repeat bottom;
  background-size: 100%;
  position: relative;
}
.infoItemsTitle {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
}
.infoItemsTitle2 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
}
.user-info-items {
  width: 6.6rem;
  height: 3.16rem;
  background: #fff;
  border-radius: 10px;
  margin: 20px auto;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}
</style>

<script>
import TabBar from "@/components/TabBar.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);

export default {
  name: "MineIndex",
  components: {
    TabBar,
    LoginDialog,
  },
  data: function () {
    return {
      loginShow: false,
      row: {
        face: "",
        name: "",
      },
    };
  },
  filter: {},
  mounted() {
    document.title = "个人中心";
  },
  created() {
    this.getUserDetail();
  },
  destroyed() {},
  methods: {
    getUserDetail() {
      let that = this;
      this.$api.get(
        "/api/user/userPage",
        {},
        (res) => {
          console.log(res);
          that.row = res.data;
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.getUserDetail();
      this.$router.replace({ name: "MineIndex" });
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },

    goOrderList(status) {
      // console.log(status);
      rbLink({
        name: "OrderList",
        query: {
          status: status,
        },
      });
      // this.$router.push({
      //     path: '/orderlist',
      //     query: {
      //         status: status
      //     }
      // })
    },

    toSetting() {
      rbLink({
        name: "Setting",
      });
      //   this.$router.push({ name: "Setting" });
    },
    toAddressList() {
      rbLink({
        name: "AddressList",
      });
      //   this.$router.push({ name: "AddressList" });
    },

    goDetail(url) {
      console.log(url);
      this.$router.push(url);
    },

    goSetting() {
      this.$router.push("/user/setting");
    },
  },
};
</script>



// WEBPACK FOOTER //
// MineIndex.vue?d23e62b6